import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import ButtonHref from "../../elements/buttons/ButtonHref";
import currentAdminContext from "../../../dataManager/context/currentAdminContext";

const MobileNavbar = ({ showMobileMenu, onSetShowMobileMenu }) => {
  // This styling will be applied to a <NavLink> when the
  // route that it links to is currently selected.
  const activeClassName =
    "underline-offset-4 decoration-4 decoration-primary text-primary";

  //context variables
  const { currentAdmin } = useContext(currentAdminContext);

  const loginOrProfile =
    currentAdmin && currentAdmin.getRole === 0 ? (
      <li className="animate hover:text-primary">
        <NavLink
          to={`/user/${currentAdmin.getId}`}
          className={({ isActive }) =>
            isActive
              ? "text-primary"
              : "animate text-smoot hover:text-primary-dark"
          }
        >
          Votre profile
        </NavLink>
      </li>
    ) : (
      <li className="animate hover:text-primary">
        <NavLink
          to="/connexion/user"
          className={({ isActive }) =>
            isActive
              ? "text-primary"
              : "animate text-smoot hover:text-primary-dark"
          }
        >
          Inscription | connexion
        </NavLink>
      </li>
    );

  return (
    <section className="z-90 fixed left-0 top-0 h-screen w-full bg-secondary ">
      <div className="m-5 flex justify-end">
        <IoMdClose
          color="#EAEAEA"
          size={42}
          className="cursor-pointer rounded-full md:hidden"
          onClick={onSetShowMobileMenu}
        />
      </div>
      <div className="mt-16 ml-10 text-smoot md:px-32">
        <ul className="flex h-full flex-col space-y-10">
          <li className="animate hover:text-primary">
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? activeClassName : undefined
              }
            >
              Accueil
            </NavLink>
          </li>

          <li className="animate hover:text-primary">
            <NavLink
              to="/produits"
              className={({ isActive }) =>
                isActive ? activeClassName : undefined
              }
            >
              Tous les articles
            </NavLink>
          </li>
          <li className="animate hover:text-primary">
            <NavLink
              to="/localisation"
              className={({ isActive }) =>
                isActive
                  ? "text-primary"
                  : "animate text-smoot hover:text-primary-dark"
              }
            >
              Nous localiser
            </NavLink>
          </li>
          {loginOrProfile}
        </ul>

        <ButtonHref
          target="_blank"
          size="small"
          classe="mt-10 block"
          href="https://wa.me/237674651112"
        >
          Nous contacter
        </ButtonHref>
      </div>
    </section>
  );
};

export default MobileNavbar;
